import { Location } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminUtilComponent } from 'app/main/pages/administration-area/admin-util/admin-util.component';
import { UserService } from 'app/main/pages/administration-area/services/user.service';
import { AcceptanceService } from 'app/main/services/acceptance.service';
import { CurriculumService } from 'app/main/services/curriculum.service';
import { UtilsService } from 'app/main/services/utils.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertComponentComponent } from '../../alert/alert-component/alert-component.component';
import { ApiService } from '../../services/api.service';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';
import { CustomValidator } from '../../validators/custom-validators';
import { VievProfessorCurriculumComponent } from '../view-professor-curriculum/view-professor-curriculum.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends AdminUtilComponent implements OnInit {

  user: any;
  relatedBanks: Array<any> = [];

  form: FormGroup;
  showForm: boolean;

  isModal: boolean;
  isProfessor: boolean;
  disabledInput: boolean;

  showCredit: boolean;
  dateToShow: any;
  actualCredit: any;
  creditLabel: string;


  today: Date;
  state: any;
  selectedUser: any;
  cantEdit: boolean;

  userSubscription: Subscription;

  curriculumFileId: string;
  @ViewChild('fileInput') fileInput: ElementRef;
  formData: FormData;
  photo: any;
  acceptedMyPhotoTypes = ['image/jpeg', 'image/png'];

  showDeleteMyAccountRequestSection: boolean;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ProfileComponent>,
    private dialogMat: MatDialog,
    private snackBarMat: MatSnackBar,
    private _formBuilder: FormBuilder,
    private userService: UserService,
    private localAccountService: LocalAccountService,
    private location: Location,
    private loaderService: LoaderService,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private curriculumService: CurriculumService,
    private apiService: ApiService,
    private acceptanceService: AcceptanceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public datas: any
  ) {
    super(dialogMat, snackBarMat);
    this.formData = new FormData();
    this.disabledInput = true;
    if (this.datas) {
      this.isModal = true;
    } else {
      this.isModal = false;
    }
    this.today = new Date();
    this.showDeleteMyAccountRequestSection = true;
  }
  async initialize() {
    // Catches state data from route
    this.state = this.route.paramMap.pipe(map(() => window.history.state));

    // Subreices to the statew
    this.selectedUser = this.state.subscribe(async (res: any) => {
      this.selectedUser = res.user;
      if (!this.selectedUser) {
        if (this.router.navigated) {
          this.location.back(); // OK
        } else {
          this.router.navigateByUrl('/administration-area/backoffice-dashboard');
        }
      } else {
        this.user = this.selectedUser;
        this.buildGenericForm();
        this.cantEdit = true;
      }
      await this.retrieveMyPhoto();
    });
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    console.log(this.router);
    if (this.router.url.includes('userProfile')) {
      await this.initialize();
    } else {
      this.showForm = false;
      // Recevies data from for profile
      if (this.isModal) {
        this.userSubscription = await this.userService.getUserInfo().subscribe(async (data: any) => {
          this.user = data.payload;
          await this.retrieveMyPhoto();
          this.buildGenericForm();
        });
      } else {
        this.userSubscription = await this.userService.getUserInfo().subscribe(async (data: any) => {
          this.user = data.payload;
          await this.retrieveMyPhoto();
          this.buildGenericForm();
        });
      }
    }
  }

  async retrieveMyPhoto() {
    if (this.user && this.user.myPhotoId) {
      if (this.localAccountService.isStudent() || this.localAccountService.isProfessor()) {
        this.photo = await this.userService.renderMyPhoto();
      } else {
        this.photo = await this.userService.renderUserPhoto(this.user.id, this.user.myPhotoId);
      }
    }
    if (!this.photo) {
      this.photo = '/assets/images/user-default-image.jpg';
    }

  }

  buildGenericForm() {
    this.form = this._formBuilder.group({
      name: new FormControl({ value: this.user.name, disabled: this.disabledInput }, Validators.required),
      surname: new FormControl({ value: this.user.surname, disabled: this.disabledInput }, Validators.required),
      username: new FormControl({ value: this.user.username, disabled: true }, Validators.required),
      // homePhone: new FormControl({ value: this.user.homePhone, disabled: this.disabledInput }, Validators.compose([CustomValidator.phoneNumber])),
      phone: new FormControl({ value: this.user.phone, disabled: this.disabledInput }, Validators.compose([CustomValidator.phoneNumber])),
      birthDate: new FormControl({ value: this.user.birthDate, disabled: this.disabledInput }, null),
      via: new FormControl({ value: this.user.via, disabled: this.disabledInput }, null),
      numeroCivico: new FormControl({ value: this.user.numeroCivico, disabled: this.disabledInput }, null),
      cap: new FormControl({ value: this.user.cap, disabled: this.disabledInput }, Validators.compose([CustomValidator.integerNumber])),
      codiceFiscale: new FormControl({ value: this.user.codiceFiscale, disabled: this.disabledInput }, Validators.compose([CustomValidator.fiscalCode]))
    });

    if (this.localAccountService.isProfessor()) {
      this.isProfessor = true;
      this.form.addControl('curriculumFileId', new FormControl({ value: this.curriculumFileId, disabled: false }, null));
      // this.form.addControl('iban', new FormControl({ value: this.user.iban, disabled: this.disabledInput }, Validators.compose([Validators.required, CustomValidator.iban])));
    } else if (this.localAccountService.isStudent()) {
      this.isProfessor = false;
      /* DECOMMENTARE PER SHOW CREDIT */
      // console.log(this.user.credit);
      this.checkIfShowCredit(false);
    } else {
      this.checkIfShowCredit(true);
    }
    this.showForm = true;
  }

  checkIfShowCredit(isAdminOrOperator) {
    this.showCredit = false;
    return false;
    if (isAdminOrOperator) {
      // se profilo loggato ADMIN OR OPERATOR
      if (this.user.ruolo === 'STUDENT') {
        this.showCredit = true;
        this.creditLabel = 'Attuale credito discente: ';
        if (!this.user.credit) {
          this.actualCredit = 0.00;
          this.dateToShow = null;
        } else {
          this.actualCredit = this.user.credit;
          this.dateToShow = moment(this.user.creditExpireDate).format('DD/MM/YYYY');
        }
      }
    } else {
      // se profilo loggato STUDENTE
      this.showCredit = true;
      this.creditLabel = 'Il tuo credito attuale: ';
      this.actualCredit = 0.00;
      this.dateToShow = null;
      let today: any = new Date();
      today = moment(today).valueOf();
      if (this.user.creditExpireDate) {
        const expireDate = moment(this.user.creditExpireDate).valueOf();
        if (today < expireDate) {
          if (!this.user.credit) {
            this.actualCredit = 0.00;
            this.dateToShow = null;
          } else {
            this.actualCredit = this.user.credit;
            this.dateToShow = moment(this.user.creditExpireDate).format('DD/MM/YYYY');
          }
        } else {
          this.actualCredit = 0.00;
          this.dateToShow = null;
        }
      }
    }
  }

  startEditProfile(disabledInput) {
    this.disabledInput = !disabledInput;
    this.buildGenericForm();
  }

  async editProfile(value) {
    value.id = this.user.id;
    if (value.codiceFiscale) {
      value.codiceFiscale = value.codiceFiscale.toUpperCase();
    }
    if (this.curriculumFileId === value.curriculumFileId) {
      delete value.curriculumFileId;
    }

    this.loaderService.showLoader();
    const newUser: any = await this.userService.editUserPromise(value).catch(err => {
      console.error = err;
      this.loaderService.hideLoader();
    });
    const oldAccount: any = await this.localAccountService.getAccount().catch(err => {
      console.error = err;
      this.loaderService.hideLoader();
    });
    if (oldAccount) {
      newUser.payload.token = oldAccount.token;
    }
    if (newUser && newUser.ok) {
      this.user = newUser.payload;
      this.utilsService.newSuccessSnackbar(`Profilo aggiornato con successo.`);
      this.disabledInput = true;
      this.buildGenericForm();
      this.loaderService.hideLoader();
    } else {
      this.utilsService.newErrorSnackbar(`Si è verificato un errore, profilo non salvato`);
      this.loaderService.hideLoader();
    }
    this.localAccountService.setAccount(this.user);
  }

  saveTempFiles(ev) {
    this.form.controls.curriculumFileId.setValue(ev);
  }

  goToEditcurriculum() {
    this.router.navigateByUrl('/users-area/professor-curriculum');
  }


  /* private buildPasswordFields() {
    let passwordsFields = {
      matchingPasswords: this.formBuilder.group({
        password: new FormControl('', Validators.compose([
          Validators.required,
          (formControl: FormControl) => PasswordFormatValidator.correctFormat(formControl)
        ])),
        passwordConfirm: new FormControl('', Validators.required)
      }, {
          validator: (formGroup: FormGroup) => {
            PasswordValidator.areEqual(formGroup);
          }
        })
    }
    return passwordsFields;
  } */

  changePassword() {
    const passwordFormGroup = this._formBuilder.group({
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required),
      oldPassword: new FormControl('', Validators.required)
    }, {
      validator: (formGroup: FormGroup) => {
        this.passwordConfirming(formGroup);
      }
    });


    // Opens new dialog to change password

    const passwordChange = async () => {
      this.loaderService.showLoader();
      const resetPasswordData = {
        nuovaPassword: passwordFormGroup.controls.password.value,
        password: passwordFormGroup.controls.oldPassword.value
      };
      this.userService.changeMyPassword(resetPasswordData).subscribe((res: any) => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        if (this.dialog) {
          this.dialog.closeAll();
        }
        this.loaderService.hideLoader();
        this.snackBarMat.open(res.infos.mainMessage, '', {
          duration: 3000,
          panelClass: 'success',
        });
      },
        (error) => { console.error(error); this.loaderService.hideLoader(); });
      // myFormGroup.controls.password.setValue(passwordFormGroup.controls.password.value);
    };

    this.newDialog({
      topHeader: 'Cambia la Password',
      button: 'Cambia la Password',
      passwords: [
        { placeholder: 'Password attuale', formControlName: 'oldPassword', type: 'password' },
        { placeholder: 'Nuova Password', formControlName: 'password', type: 'password' },
        { placeholder: 'Conferma password', formControlName: 'confirmPassword', type: 'password' },
      ],
      formGroup: passwordFormGroup,
      callback: passwordChange
    }, passwordChange);


  }

  // Changes image
  changeImage() {
    // const dialog = this.dialogMat.open(ImageCropComponent, {
    //   width: '400px',
    //   panelClass: 'custom-panel-class',
    // });
  }

  showAlertOnUploadPhotoFile() {
    const confirmDialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        title: 'La modifica della tua foto sara\'istantanea e non ti verra\' chiesta altra conferma, sei sicuro di voler procedere?',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              confirmDialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'warn',
            close: true,
            value: true,
            callback: async () => {
              this.fileInput.nativeElement.click();
            }
          }
        ],
      }
    });

  }

  async uploadMyPhoto(event) {
    const filesToUpload = event.target.files as Array<File>;
    if (filesToUpload && filesToUpload.length > 0) {
      for (const file of filesToUpload) {
        this.formData.append('file', file, file.name);
      }
      this.loaderService.showLoader();
      await this.userService
        .uploadMyPhoto(this.formData)
        .then(async res => {
          this.utilsService.newSuccessSnackbar(
            'Il caricamento è andato a buon fine'
          );
          await this.userService.getUserInfoPromise().then(async (res: any) => {
            this.user = res.payload;
            await this.retrieveMyPhoto();
          }).catch(err => {

          }).finally(() => {
          });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.formData = new FormData();
          this.fileInput.nativeElement.value = null;
          this.loaderService.hideLoader();
        });
    }
  }

  // Checks password
  passwordConfirming(formGroup: FormGroup): { invalid: boolean } {

    const firstPassword = formGroup.controls.password.value;
    const secondPassword = formGroup.controls.confirmPassword.value;
    if ((firstPassword && secondPassword) && (firstPassword !== secondPassword)) {
      formGroup.controls.confirmPassword.setErrors({ notMatch: true });
      return { invalid: true };
    } else {
      return null;
    }
  }

  goBack() {
    if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
      if (this.router.navigated) {
        this.location.back(); // OK
      } else {
        this.router.navigateByUrl('/administration-area/backoffice-dashboard');
      }
    } else {
      if (this.router.navigated) {
        this.location.back(); // OK
      } else {
        this.router.navigateByUrl('/common-area/salespackage-offer');
      }
    }
  }

  async openCurriculumPreview() {
    if (this.user.curriculumEntityId) {
      this.loaderService.showLoader();
      const curriculum: any = await this.curriculumService.getCurriculumById(this.user.curriculumEntityId).catch((err) => {
        this.loaderService.hideLoader();
      });
      if (curriculum) {
        if (curriculum.ok) {
          if (curriculum.payload) {
            this.loaderService.hideLoader();
            const openPreview = this.dialog.open(VievProfessorCurriculumComponent, {
              width: '400px',
              maxHeight: '80vh',
              panelClass: 'custom-panel-class',
              data: {
                professor: this.user,
                curriculum: curriculum.payload
              }
            });
          }
        }
      }
    } else {
      this.utilsService.newErrorSnackbar('Il formatore non ha ancora caricato un curriculum', 2000);
    }
  }

  async downloadCurriculum() {
    if (this.user.curriculumFileId && this.user.downloadCurriculumFileUrl) {
      this.loaderService.showLoader();
      const res: any = await this.apiService.downloadFile(this.user.downloadCurriculumFileUrl, this.user.curriculumFileId).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loaderService.hideLoader();
      });
    }
  }
  async updateAcceptance(value) {
    const confirmDialog = this.dialog.open(AlertComponentComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {
        innerHTML: true,
        body: '<p>Sei sicuro di voler modificare le autorizzazioni concesse?</p>',
        title: 'Modifica Autorizzazioni',
        buttons: [
          {
            text: 'Annulla',
            color: 'default',
            close: true,
            value: false,
            callback: async () => {
              confirmDialog.close();
            }
          },
          {
            text: 'Conferma',
            color: 'warn',
            close: true,
            value: true,
            callback: async () => {
              if (value) {
                this.loaderService.showLoader();
                let userInfo: any = await this.userService.getUserInfoPromise();
                if (userInfo) {
                  let res: any = await this.acceptanceService.myAcceptances(value).catch((err) => {
                    console.error(err);
                  }).finally(() => {
                    this.loaderService.hideLoader()
                  });
                  if (res) {
                    if (res.ok) {
                      const token = this.localAccountService.getToken();
                      let acc = res.payload;
                      acc.token = token;
                      this.localAccountService.setAccount(acc);
                      this.router.navigateByUrl('public-area/redirect');
                    }
                  }
                }
              }

            }
          }
        ],
      }
    });
  }
}
